<template>
    <Head>
        <title>{{ page.meta_title ?? page.title }}</title>
        <meta name="description" content="{{ page.meta_description }}"/>
    </Head>

    <FrontendLayout>
        <template #content>
            <div class="container mx-auto mb-8">
                <div class="mx-auto mt-12 flex max-w-[1034px] p-4 pb-8">
                    <cms-header
                        :text="title"
                        css-classes="handwritten-underline-lg"
                    ></cms-header>
                </div>

                <div class="container mx-auto max-w-[1034px]">
                    <div class="float-right ml-8 hidden md:block">
                        <div class="mb-8">
                            <emtprep-upsell-ad/>
                        </div>
                        <div class="mb-8">
                            <emtce-promo-ad/>
                        </div>
                    </div>
                    <div
                        class="cms-wysiwyg-content order-1 flex-grow md:order-2"
                        v-html="page.html_content"
                    ></div>
                    <div class="md:hidden">
                        <div class="mb-8">
                            <emtprep-upsell-ad/>
                        </div>
                        <div class="mb-8">
                            <emtce-promo-ad/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </FrontendLayout>
</template>

<script>
import CmsHeader from "@/Components/CmsHeader.vue";
import EmtprepUpsellAd from "@/Components/EmtprepUpsellAd.vue";
import EmtcePromoAd from "@/Components/EmtcePromoAd.vue";
import FrontendLayout from "@/Layouts/FrontendLayout.vue";

export default {
    name: "cms-template-basic",
    components: {CmsHeader, EmtcePromoAd, EmtprepUpsellAd, FrontendLayout},
    props: {
        title: {
            type: String,
            default: "Title",
        },
        page: {
            type: Object,
            default: {},
        },
    },
};
</script>
